<template>
  <div
    class="tag-wrapper"
    v-click-outside="closeEdit"
    @click="(showTable = true), (clickedForPopUp = true)"
    @mouseleave="!clickedOnDateChange ? (showTable = false) : ''"
  >
    <!--    @mouseenter="showTable = true"-->
    <span
      class="label tag-lead table-tag-content"
      @mouseleave="
        clickedForPopUp ? (clickedForPopUp = false) : (showTable = false)
      "
    >
      <!--      @click="filterMain"-->
      <span class="tagNameDesign">LD</span>
      {{ formatDate(leads[0].created_at) }}
      <span class="forNumOutOfName" v-if="leads.length > 1">{{
        leads.length
      }}</span>
      <a @click.prevent="$emit('delete')"
        ><span v-if="showRemove" class="fas fa-times remove-tag-icon"></span></a
    ></span>
    <!--    @mouseenter="showTable = false"-->

    <div v-if="showTable" class="tag-table pop-up-for-tags">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th class="t-header">DATE</th>
              <th class="t-header">TIME</th>
              <th class="t-header">BROKER</th>
              <th class="t-header">AGENT</th>
              <th class="t-header">
                <i
                  @mouseenter="[(showTable = false)]"
                  class="fa fa-times"
                  aria-hidden="true"
                ></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lead in leads" :key="lead.id">
              <!--              normal date mode-->
              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(lead)
                }"
                v-show="
                  requestForDate.tagName !== 'ld' ||
                    requestForDate.id !== lead.id
                "
              >
                {{ formatDateTable(lead.created_at) }}
                <i
                  v-if="
                    requestForDate.date == null || requestForDate.time == null
                  "
                  class="fas fa-edit clickable"
                  @click="[sendVuexToCal(lead), (clickedOnDateChange = true)]"
                ></i>
                <i
                  @click="sendNewDateFromPopUpToDB"
                  class="fas fa-check pointer"
                  v-if="
                    requestForDate.date != null &&
                      requestForDate.time != null &&
                      requestForDate.id === lead.id
                  "
                ></i>
              </td>
              <!--              edit date mode-->
              <td
                v-show="
                  requestForDate &&
                    requestForDate.tagName === 'ld' &&
                    requestForDate.id === lead.id
                "
                class="text-danger"
              >
                <i
                  v-if="
                    requestForDate.date == null || requestForDate.time == null
                  "
                  class="fas fa-window-close clickable"
                  @click="[sendVuexToCal(), (clickedOnDateChange = true)]"
                ></i>
                <i
                  @click="sendNewDateFromPopUpToDB"
                  class="fas fa-check pointer"
                  v-if="
                    requestForDate.date != null &&
                      requestForDate.time != null &&
                      requestForDate.id === lead.id
                  "
                ></i>

                {{ textOrDate }}
              </td>
              <!--              end edit date mode-->

              <td
                :class="{
                  inBetweenSelectedCalDates: checkSelectedCalDates(lead)
                }"
              >
                <span
                  class="text-danger"
                  v-if="
                    requestForDate.date != null &&
                      requestForDate.time != null &&
                      requestForDate.id === lead.id
                  "
                  >{{ requestForDate.time }}:00</span
                >
                <span v-else>{{ lead.created_at | shortTime }}</span>
              </td>
              <td>{{ lead.campaign.name }}</td>
              <!--              <td class="d-none">{{ formatDate(lead.payment_on) }}</td>-->
              <td>{{ lead.user.full_name }}</td>
              <td>{{ lead.comment }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <Tooltip
      v-if="showToolTip"
      :direction="'top'"
      :group="'tags'"
      :tooltip-selector="'lead-tag'"
    />
  </div>
</template>

<script>
import moment from "moment";
import vClickOutside from "v-click-outside";
import { mapState } from "vuex";
import apiClientCreator from "../../../../../../helpers/api/request";
import Tooltip from "../../../../../../main/util.main/Tooltip.component";

export default {
  name: "leads",
  components: { Tooltip },
  directives: {
    clickOutside: vClickOutside.directive
  },
  computed: {
    ...mapState("clients", ["requestForDate", "generalQueryObject"])
  },
  props: {
    leads: {
      type: Array,
      required: true
    },
    showRemove: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      showTable: false,
      showToolTip: false,
      textOrDate: "Choose date",
      editId: null,
      // dateChange: null,
      clickedOnDateChange: false,
      recId: null,
      tagName: null,
      newDate: null,
      newHours: null,
      total: null,
      clickedForPopUp: false
    };
  },
  watch: {
    requestForDate: function() {
      if (this.requestForDate.time != null) {
        this.textOrDate =
          this.requestForDate.date + " " + this.requestForDate.time;
      }
      if (this.requestForDate.date != null) {
        this.textOrDate = this.requestForDate.date;
      }
      // this.dateChange = this.requestForDate.date;
      if (
        this.requestForDate.direction === "FROM_CAL" &&
        this.requestForDate.id === this.editId &&
        this.requestForDate.tagName === "ld"
      ) {
        // console.log( this.requestForDate.id)
        this.recId = this.requestForDate.id;
        this.tagName = this.requestForDate.tagName;
        this.newDate = this.requestForDate.date;
        this.newHours = this.requestForDate.time;
        this.total = moment(
          `${this.newDate} ${this.newHours}`,
          "YYYY-MM-DD HH:mm:ss"
        ).format("YYYY-MM-DD HH:mm:ss");
        this.editId = null;
      }
    }
  },
  methods: {
    sendNewDateFromPopUpToDB() {
      const apiUpdatedDate = apiClientCreator(
        `client/updatedDateFromPopUp/${this.recId}`
      );
      apiUpdatedDate
        .post("", {
          updated_at: this.total,
          tag_name: this.tagName
        })
        .then(e => {
          this.$emit("updated");
          this.clickedOnDateChange = false;
          this.$store.commit("clients/setRequestForDate", {});
        });
    },

    checkSelectedCalDates(ldDit) {
      let ldIn = moment(ldDit.created_at);
      let start = moment(
        this.generalQueryObject.last_modified_lead_from
      ).startOf("day");
      let to = moment(this.generalQueryObject.last_modified_lead_to).endOf(
        "day"
      );
      if (ldIn.isBetween(start, to)) {
        return true;
      } else {
        return false;
      }
    },
    sendVuexToCal(lead = null) {
      if (lead) {
        this.editId = lead.id;
        this.$store.commit("clients/setRequestForDate", {
          tagName: "ld",
          fromWhere: "lead",
          calendar: "LEAD_TAG",
          id: lead.id,
          direction: "FROM_TAG"
        });
      } else {
        this.$store.commit("clients/setRequestForDate", {});
      }
    },
    closeEdit() {
      this.clickedForPopUp = false;
      if (
        this.requestForDate.direction !== "FROM_TAG" &&
        this.requestForDate.id !== this.editId &&
        this.requestForDate.date == null &&
        this.requestForDate.time == null
      ) {
        this.showTable = false;
        this.recId = null;
        this.tagName = null;
        this.newDate = null;
        this.newHours = null;
        this.total = null;
      }
    },
    // filterMain() {
    //   this.$store.commit("clients/setFilterToMain", {
    //     title: "ld",
    //     type: true
    //   });
    // },
    formatDate(date) {
      return moment(String(date)).format("HH:mm DD/MM ");
    },
    formatDateTable(date) {
      // this.dateChange = moment(String(date)).format("DD/MM");
      return moment(String(date)).format("DD/MM");
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-wrapper {
  display: inline-flex;
  position: relative;
  font-family: Montserrat !important;
}

.tag-lead {
  background-color: #4275ec;
  /*font-size: 12px;*/
  /*color: white;*/
  /*!*font-size: 11px;*!*/
  /*margin: 2px;*/
  /*font-weight: 500;*/
  /*padding: 4px;*/
  /*padding: 4px;*/
  /*font-family: Montserrat !important;*/
  /*line-height: 2;*/
  /*cursor: pointer;*/
  /*animation: flash linear 1s;*/
}
.table {
  margin-bottom: 0px !important;
  transform: scaleX(-1);
}

@keyframes flash {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 3;
  }
}

.tag-table {
  bottom: 34px !important;
  border: solid 1px #4275ec;
  text-align: center;
  max-height: 267px;
  overflow-y: hidden;
}

.table-responsive {
  margin-bottom: 0px;
  border-radius: 5px;
  overflow: auto;
  max-height: 267px;
  transform: scaleX(-1);
}

.tag-time {
  font-size: 8pt;
}

.remove-tag-icon {
  /*color: white;*/
  /*cursor: pointer;*/
  /*margin-left: 5px;*/
  color: white;
  cursor: pointer;
  margin-left: 0px;
  position: absolute;
  left: 11px;
  font-size: 17px;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 6px;
  padding-right: 6px;
  border: 1px solid black;
  border-radius: 5px;
  top: 6px;
  background: black;
}
.remove-tag-icon:hover {
  color: white;
  background: black;
}
/*.remove-tag-icon:hover {*/
/*  color: #f44336;*/
/*}*/
.label {
  padding: 4px 2px 4px 2px;
  font-size: 12px;
}
.tagNameDesign:hover {
  font-size: 12px !important;
}
.d-none {
  display: none;
}
.forNumOutOfName {
  font-weight: 100 !important;
}
.clickable {
  color: lightskyblue;
}
.clickable:hover {
  cursor: pointer;
}
.inBetweenSelectedCalDates {
  /*background: lightgrey;*/
  /*border: 1px solid white !important;*/
  color: blue;
}

tbody > tr:nth-of-type(odd) {
  background-color: #7a7a7a0d;
}

.t-header {
  position: sticky;
  top: 0;
  background-color: white !important;
}
.pointer {
  cursor: pointer;
}
/*!* width *!
::-webkit-scrollbar {
  width: 3px;
}

!* Handle *!
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}*/

.pointer:hover {
  background-color: unset !important;
}
th.t-header {
  z-index: 2;
}
.clickable:hover {
  background-color: unset !important;
}
.fa-times {
  cursor: pointer;
}

.table-responsive::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.table-responsive::-webkit-scrollbar {
  width: 7px;
  background-color: #f5f5f5;
  /*display: none;*/
}

.table-responsive::-webkit-scrollbar-thumb {
  background-color: #7a7a7a;
  border: 2px solid #555555;
  border-radius: 5px;
}
</style>
